export const STANDARDS_SET_MODE = {
  CREATE: "create",
  EDIT: "edit",
  DELETE: "delete",
  VIEW: "view",
} as const;

export type IStandardsSetMode =
  (typeof STANDARDS_SET_MODE)[keyof typeof STANDARDS_SET_MODE];
